import { render, staticRenderFns } from "./LoginSSO.vue?vue&type=template&id=23cc75cc&scoped=true"
import script from "./LoginSSO.vue?vue&type=script&lang=js"
export * from "./LoginSSO.vue?vue&type=script&lang=js"
import style0 from "./LoginSSO.vue?vue&type=style&index=0&id=23cc75cc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23cc75cc",
  null
  
)

export default component.exports